module.exports = {"id":"146953","name":"Manu Del Moral","rating":"72","photo":"./data/images/photos/0/146953.png","club":{"name":"CD Numancia","logo":"./data/images/clubs/CDNumancia.png"},"positions":["BU","MG","MD","MOC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ManuDelMoral0.json
// module id = 2675
// module chunks = 0